var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dv-border-box-7',[_c('div',{staticClass:"hd"},[_vm._v("未来健康")]),_c('dv-capsule-chart',{staticStyle:{"width":"100%","height":"50px"},attrs:{"config":_vm.config}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }